import React from 'react'
import Calendar, { CalendarWrapper } from '../../../../../../components/Calendar';
import ListItem from '../../../../../../components/ListItem';
import { CardActivity } from '../../../../../../components/Card';
import Icon from '../../../../../../components/Icon';
import { ListContainer, ListWrap } from '../../../../../../components/ListItem/styled';
import Days from '../../../../../../components/Days';
import { StyledTitle } from './styled';
import { length } from 'ramda';

const ZoneStatus = ({ zoneStatus }) => {
    return (
        <CalendarWrapper>
            {
                zoneStatus &&
                <>
                    <StyledTitle>{zoneStatus.params.title}</StyledTitle>
                    <Calendar
                        days={zoneStatus.params.calendar || []}
                        content={(renderedDays) => {
                            const filterDays = (days) => {
                                return days.filter(day => renderedDays.map(renderedDay => renderedDay.stamp).includes(day.stamp)).sort((a, b) => a.stamp - b.stamp);
                            }
                            return (
                                zoneStatus.params.data &&
                                zoneStatus.params.data.map(item => (
                                    <ListItem
                                        key={item.row_id}
                                        to={{
                                            pathname: `/manage/zones/${item.name.split(' ').join('-').toLowerCase()}`,
                                            state: {
                                                rowid: item.row_id
                                            }
                                        }}
                                        arrow={false}
                                    >
                                        <ListContainer
                                            noMargin
                                        >
                                            <ListWrap>
                                                <CardActivity
                                                    title={item.title}
                                                    values={item.days && <Days daysLength={length(renderedDays)} items={filterDays(item.days)} />}
                                                    noMargin
                                                />
                                                <Icon name="arrow" />
                                            </ListWrap>
                                        </ListContainer>
                                    </ListItem>
                                ))
                            )
                        }}
                        fullContent
                    />
                </>
            }
        </CalendarWrapper>
    )
}

export default ZoneStatus
